export const mockExistingUsers = [
  {
    id: "user1",
    name: "John Doe",
    selectedPermission: "VIEW",
  },
  {
    id: "user2",
    name: "Jane Smith",
    selectedPermission: "UPDATE",
  },
];